import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import Divider from "@material-ui/core/Divider";

import DashboardIcon from "../../../../../Assets/Logo/DashboardIcon.svg";
import FeeIcon from "../../../../../Assets/Logo/FeeIcon.svg";
import ExaminationIcon from "../../../../../Assets/Logo/ExaminationIcon.svg";
import ResultIcon from "../../../../../Assets/Logo/ResultIcon.svg";
import NoticeIcon from "../../../../../Assets/Logo/NoticeIcon.svg";
import AttendanceIcon from "../../../../../Assets/Logo/AttendanceIcon.svg";
import SyllabusIcon from "../../../../../Assets/Logo/SyllabusIcon.svg";
import AssignmentIcon from "../../../../../Assets/Logo/AssignmentIcon.svg";
import TimetableIcon from "../../../../../Assets/Logo/TimetableIcon.svg";
import LibraryIcon from "../../../../../Assets/Logo/LibraryIcon.svg";
import AboutIcon from "../../../../../Assets/Logo/AboutIcon.svg";

import { useStyles } from "./UserMenuDrawer.css";

class UserMenuDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [
        {
          name: "Dashboard",
          defaultUrl: "/dashboard",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={DashboardIcon}
              alt="Dashboard"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Fees",
          defaultUrl: "/fees",
          value: false,
          role: ["Student", "Parent"],
          icon: (
            <img src={FeeIcon} alt="Fee" style={{ width: 30, height: 30 }} />
          ),
        },
        {
          name: "Examination",
          defaultUrl: "/examination",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={ExaminationIcon}
              alt="Examination"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Results",
          defaultUrl: "/result",
          value: false,
          role: ["Student", "Parent"],
          icon: (
            <img
              src={ResultIcon}
              alt="Result"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Notice",
          defaultUrl: "/notices",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={NoticeIcon}
              alt="Notices"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Attendance",
          defaultUrl: "/attendance",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={AttendanceIcon}
              alt="Attendance"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Syllabus and More",
          defaultUrl: "/syllabus",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={SyllabusIcon}
              alt="Syllabus"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Assignments",
          defaultUrl: "/assignments",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={AssignmentIcon}
              alt="Academics"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "TimeTable",
          defaultUrl: "/timetable",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={TimetableIcon}
              alt="Timetable"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Library",
          defaultUrl: "/library",
          value: false,
          role: ["Student"],
          icon: (
            <img
              src={LibraryIcon}
              alt="Library"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
      ],
      generalMenu: [
        {
          name: "About Us",
          defaultUrl: "/about",
          value: false,
          role: ["Student", "Parent", "Teacher"],
          icon: (
            <img
              src={AboutIcon}
              alt="about"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
      ],
    };
  }

  render() {
    const { classes } = this.props;
    const { generalMenu } = this.state;
    let studentMenu = this.state.menu.filter((data) =>
      data.role.includes("Student")
    );
    let parentMenu = this.state.menu.filter((data) =>
      data.role.includes("Parent")
    );
    let teacherMenu = this.state.menu.filter((data) =>
      data.role.includes("Teacher")
    );
    let userMenu =
      this.props.role === "Student"
        ? studentMenu
        : this.props.role === "Parent"
        ? parentMenu
        : this.props.role === "Teacher" && teacherMenu;
    return (
      <div className={classes.root}>
        <div className={classes.sectionDesktop}>
          {this.props.open ? (
            <List style={{ width: "100%" }}>
              {userMenu.map((menu, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => this.props.history.push(menu.defaultUrl)}
                >
                  <Tooltip arrow title={<h1>{menu.name}</h1>}>
                    {menu.icon}
                  </Tooltip>
                  <div style={{ marginLeft: 10 }}>{menu.name}</div>
                </ListItem>
              ))}
            </List>
          ) : (
            <List style={{ width: "100%" }}>
              {userMenu.map((menu, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => this.props.history.push(menu.defaultUrl)}
                >
                  <Tooltip
                    arrow
                    title={<div style={{ fontSize: 14 }}>{menu.name}</div>}
                  >
                    {menu.icon}
                  </Tooltip>
                </ListItem>
              ))}
            </List>
          )}
        </div>
        <div className={classes.sectionMobile}>
          <List>
            {userMenu.slice(1, userMenu.length).map((menu, index) => (
              <ListItem
                button
                key={index}
                onClick={() => this.props.history.push(menu.defaultUrl)}
              >
                <Tooltip arrow title={<h1>{menu.name}</h1>}>
                  {menu.icon}
                </Tooltip>
                <div style={{ marginLeft: 20 }}>{menu.name}</div>
              </ListItem>
            ))}
            <Divider flexItem style={{ height: 1 }} />
            {generalMenu.map((menu, index) => (
              <ListItem
                button
                key={index}
                onClick={() => this.props.history.push(menu.defaultUrl)}
              >
                <Tooltip arrow title={<h1>{menu.name}</h1>}>
                  {menu.icon}
                </Tooltip>
                <div style={{ marginLeft: 20 }}>{menu.name}</div>
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(UserMenuDrawer));
